import { Controller } from 'stimulus';
import $ from 'jquery';

class HeaderController extends Controller {
  initialize() {
    this.HEADER_BREAKPOINT = 100;
    this.scrolling = false;
    this.scroll_events = [];
    this.body = $('body');
  }

  connect() {
    if(this.data.has('adaptOnScroll')) {
      this.adaptOnScroll();

      // if the header is past the breakpoint already
      // (usually when the user hits the back button)
      // make sure it's the correct the bg
      if(window.scrollY > this.HEADER_BREAKPOINT) {
        this.setBackground(this.data.get('primary-bg'));
      }
    }

    if(this.data.has('shouldAdjustForAlert')) {
      this.adjustForAlert();
    }

    // start the scroll listener if any method is using it
    if(this.data.has('adaptOnScroll') || this.data.has('shouldAdjustForAlert')) {
      $(window).on('scroll', () => {
        this.scrolling = true;
      });

      setInterval(() => {
        if(this.scrolling) {
          this.scrolling = false;
          this.scroll_events.forEach(scroll_event => scroll_event());
        }
      }, 250);
    }
  }

  toggleMenu() {
    this.menuTarget.classList.toggle('opacity-0');
    this.menuTarget.classList.toggle('opacity-100');
    this.menuTarget.classList.toggle('translate-x-full');
    this.menuTarget.classList.toggle('translate-x-0');
    this.menuButtonTarget.classList.toggle('hidden');
    this.closeButtonTarget.classList.toggle('hidden');
    this.languageSwitcherTarget.classList.toggle('language-switcher__hidden');
    document.body.classList.toggle('lock-body-for-mobile-menu');
  }

  adaptOnScroll() {
    this.adaptedValue = false;

    this.scroll_events.push(() => {
      const { scrollY } = window;
      const toggle = () => {
        window.requestAnimationFrame(() => {
          this.setBackground(scrollY > this.HEADER_BREAKPOINT ? this.data.get('primary-bg') : 'bg-none');
          this.element.classList.toggle('h-20');
          this.element.classList.toggle('h-16');
          this.element.classList.toggle('md:h-24');
          this.element.classList.toggle('md:h-20');
        });
      }

      if(scrollY > this.HEADER_BREAKPOINT && !this.adaptedValue) {
        toggle();
        this.adaptedValue = true;
      }

      if(scrollY < this.HEADER_BREAKPOINT && this.adaptedValue) {
        toggle();
        this.adaptedValue = false;
      }
    });
  }

  setBackground(background) {
    if(background === this.data.get('background')) return;
    this.element.classList.remove(this.data.get('background'));
    this.element.classList.add(background);
    this.data.set('background', background);
  }

  adjustForAlert() {
    // this only runs if there is an alert AND the header is fixed
    const alert = document.querySelector('.alert');
    const alert_height = window.getComputedStyle(alert).getPropertyValue('height');
    let current_position = 'absolute';
    this.element.style.position = 'absolute';
    this.element.style.top = alert_height;

    this.scroll_events.push(() => {
      const { scrollY } = window;
      if(scrollY > this.HEADER_BREAKPOINT && current_position !== 'fixed') {
        window.requestAnimationFrame(() => {
          this.element.style.position = 'fixed';
          this.element.style.top = 0;
        });
        current_position = 'fixed';
      }
      else if(scrollY < this.HEADER_BREAKPOINT && current_position !== 'absolute') {
        window.requestAnimationFrame(() => {
          this.element.style.position = 'absolute';
          this.element.style.top = alert_height;
        });
        current_position = 'absolute';
      }
    })
  }
}

HeaderController.targets = ['menu', 'body', 'menuButton', 'languageSwitcher', 'closeButton'];
HeaderController.values = {
  adapted: Boolean,
};

export default HeaderController;
